import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AppConfig from "../../AppConfig";

// First, create the thunk
const fetchStaff = createAsyncThunk("staff/fetchStaff", async () => {
  try {
    // Retrieve state from localStorage

    var result = await AppConfig.PostData(
      `account/ping`,
      "GET",
      null,
      false,
      false
    );
    if (result.status === 200) {
      let staff = await result.json();
      return staff;
    } else {
      return null;
    }
  } catch (error) {
    return [...error.message];
  }
});

const initialState = {
  staff: {},
  isAuthenticated: false,
  error: "",
  loading: "idle", // 'idle' | 'pending' | 'succeeded' | 'failed'
};

export const staffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    setStaff: (state, action) => {
      state.staff = [...action.payload];
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(fetchStaff.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchStaff.fulfilled, (state, action) => {
        state.loading = "succeeded";
        if (action.payload !== null) {
          state.staff = action.payload;
          state.isAuthenticated = true;
        } else {
          localStorage.setItem('access_token', null);
          state.error = "Invalid login!";
        }
      })
      .addCase(fetchStaff.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      });
  },
});

// Action creators are generated for each case reducer function
export const { setError, setStaff } = staffSlice.actions;
export { fetchStaff };

export default staffSlice.reducer;
